<template>
  <section v-loading="loading" class="p-2">
    <el-row>
      <el-button size="small" class="mb-2" @click="goBack"
        ><i class="el-icon-back"></i
      ></el-button>
    </el-row>
    <el-row>
      <el-col :span="16">
        <el-card>
          <div style="padding: 10px; border-bottom: 1px solid #ccc">
            <div style="display: flex; flex-direction: column; gap: 6px">
              <!-- Title -->
              <span style="font-size: medium; font-weight: bold">
                {{ forumData.title }}
              </span>

              <!-- Avatar + Info -->
              <div style="display: flex; align-items: center; gap: 10px">
                <!-- Avatar -->
                <div class="icon-block initial" style="margin-top: 2px">
                  <div v-if="entityUserInfoData[forumData.created_by]?.avatar">
                    <img
                      :src="entityUserInfoData[forumData.created_by].avatar"
                      alt="IMG"
                      width="40"
                      height="40"
                      style="border-radius: 50%"
                    />
                  </div>
                  <div class="icon" v-else>
                    <div class="initial-text">
                      <span>{{ getInitials(forumData) }}</span>
                    </div>
                  </div>
                </div>

                <!-- Name + Comment Info -->
                <div style="display: flex; flex-direction: column">
                  <!-- Name -->
                  <span style="font-size: 14px; font-weight: 500">
                    {{
                      entityUserInfoData[forumData.created_by] ==
                      getAuthenticatedUser._id
                        ? "You"
                        : entityUserInfoData?.[forumData.created_by]
                            ?.first_name +
                          " " +
                          entityUserInfoData?.[forumData.created_by]?.last_name
                    }}
                  </span>

                  <!-- Comments + Date -->
                  <div style="display: flex; align-items: center; gap: 6px">
                    <img
                      src="../../../public/assets/img/icons/Comment.svg"
                      width="16"
                      height="16"
                      alt="Comment"
                    />
                    <span style="color: gray">{{ totalComments }}</span>
                    <span class="date-time text-dark fw-medium opacity-50 ml-2">
                      {{
                        forumData.created_at | getFormattedDateTypeThree
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div v-html="forumData.content" style="margin-top: 6px"></div>
            <div style="margin-top: 6px">
              <span
                v-for="tag in forumData.tags"
                :key="tag"
                style="
                  color: #1890ff;
                  cursor: pointer;
                  margin-right: 6px;
                  font-size: small;
                "
                @click="openTag(tag)"
                >{{ tag }}</span
              >
            </div>
          </div>
          <div
            style="display: flex; justify-content: flex-end; margin-top: 10px"
          >
            <div
              class="like-comment-bar"
              style="
                display: flex;
                align-items: center;
                gap: 10px;
                cursor: pointer;
              "
            >
              <!-- Like Button -->
              <div style="display: flex; align-items: center; gap: 5px">
                <img
                  v-if="forumData.liked_by.includes(getAuthenticatedUser._id)"
                  width="20"
                  height="20"
                  src="../../../public/assets/img/icons/Like - Fill.svg"
                  @click="dislike(index)"
                />
                <img
                  v-else
                  width="20"
                  height="20"
                  src="../../../public/assets/img/icons/Like - Outline.svg"
                  @click="like(index)"
                />
                <span>{{ forumData.liked_by.length }}</span>
              </div>

              <!-- Vertical Divider -->
              <div
                style="width: 1px; height: 20px; background-color: #ccc"
              ></div>

              <!-- Add Comment Button -->
              <el-button size="small" @click="addComment"
                >Add Comment</el-button
              >
            </div>
          </div>
        </el-card>
        <div class="mt-2 mb-2" id="comment-section">
          <span style="font-weight: bold">{{
            "Comments(" + totalComments + ")"
          }}</span>
        </div>
        <el-card>
          <div v-if="comments.length">
            <CommentBlock
              v-for="comment in comments"
              :key="comment._id"
              :comment="comment"
              :entityUserInfoData="entityUserInfoData"
              :level="0"
              @reply="reply"
            />
          </div>
          <div v-else class="centered">
            <span style="opacity: 70%;">No Comments</span>
          </div>
        </el-card>
        <el-card class="mt-2 mb-2" id="post-comment-section">
          <div class="d-flex align-items-center mt-1 mb-1" style="gap: 10px">
            <!-- Avatar Block -->
            <div class="icon-block initial">
              <div v-if="entityUserInfoData[getAuthenticatedUser._id]?.avatar">
                <img
                  :src="entityUserInfoData[getAuthenticatedUser._id].avatar"
                  alt="IMG"
                  width="40"
                  height="40"
                  style="border-radius: 50%"
                />
              </div>
              <div class="icon" v-else>
                <div class="initial-text">
                  <span>{{
                    getInitials({ created_by: getAuthenticatedUser._id })
                  }}</span>
                </div>
              </div>
            </div>

            <!-- Text Block -->
            <div>
              <span v-if="replyToUser">
                {{
                  "Reply to " +
                  (replyToUser == getAuthenticatedUser._id
                    ? "yourself"
                    : entityUserInfoData?.[replyToUser]?.first_name +
                      " " +
                      entityUserInfoData?.[replyToUser]?.last_name)
                }}
              </span>
              <span v-else> Add Comment </span>
            </div>
          </div>

          <CkEditorOffline
            v-model="comment"
            :config="editorConfig"
            :editorId="editorConfig.id"
          ></CkEditorOffline>
          <el-button
            style="float: right; margin: 10px 0px"
            type="primary"
            size="small"
            @click="postComment"
          >
            {{ "Post " + (isNew ? "Comment" : "Reply") }}
          </el-button>
        </el-card>
      </el-col>
      <el-col :span="8">
        <div style="padding: 0px 15px">
          <el-button type="primary" @click="askQuestion" style="width: 100%"
            >Ask your question</el-button
          >
          <div class="tag-box mt-2">
            <div class="tag-header">
              <i class="el-icon-collection-tag"></i>
              <span>Related Articles</span>
            </div>
            <div
              v-for="topic in relatedForums"
              :key="topic._id"
              class="tag-row"
            >
              <div @click="openForum(topic._id)" style="cursor: pointer">
                {{ topic.title }}
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { postAPICall } from "../../helpers/httpHelper";
import CommentBlock from "./CommentBlock.vue";
import { ckEditorConfig } from "@/assets/data/ckeditor_config.ts";
export default {
  data() {
    return {
      forumData: {},
      comments: [],
      allComments: [],
      totalComments: 0,
      entityUserInfoData: {},
      loading: false,
      comment: "",
      isNew: true,
      replyToComment: "",
      replyToUser: "",
      editorConfig: ckEditorConfig,
      relatedForums: [],
    };
  },
  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    isApplicationUser() {
      return this.$route.name == "ApplicationUserForumDetailedView"
        ? true
        : false;
    },
  },
  components: {
    CommentBlock,
    CkEditorOffline: () => import("@/components/CkEditor.vue"),
  },
  async mounted() {
    await this.getNecessaryInfo();
  },
  methods: {
    async getNecessaryInfo() {
      this.loading = true;
      await postAPICall(
        "GET",
        "/forums/mark-read-comments/" + this.$route.params.forum_id
      );
      let [forumData, forums] = await Promise.all([
        postAPICall(
          "GET",
          "/forums/get-thread-by-id/" + this.$route.params.forum_id
        ),
        postAPICall(
          "GET",
          "/forums/related-threads/" + this.$route.params.forum_id
        ),
        this.fetchComments(),
      ]);
      if (forums.data.length) {
        this.relatedForums = forums.data;
      }
      if (forumData.data) {
        this.forumData = forumData.data;
        this.replyToUser = forumData.created_by;
        if (
          this.forumData.created_by != this.getAuthenticatedUser._id &&
          !this.forumData.read_by.includes(this.getAuthenticatedUser._id)
        ) {
          await postAPICall(
            "POST",
            "/forums/mark-thread-as-read/" + this.forumData._id,
            {}
          );
        }
      }
      let usersInfo = [
        this.getAuthenticatedUser._id,
        forumData?.data?.created_by,
        ...this.allComments?.map((cmnt) => cmnt.created_by),
      ];
      let usersResponse = await postAPICall(
        "POST",
        "/entities-data/users-info",
        {
          contact_ids: usersInfo,
          user_ids: usersInfo,
        }
      );
      this.entityUserInfoData = {
        ...this.entityUserInfoData,
        ...usersResponse.data,
      };
      this.loading = false;
    },
    getInitials(forum) {
      let user = this.entityUserInfoData[forum.created_by];
      return (
        user?.first_name?.charAt(0)?.toUpperCase() +
        user?.last_name?.charAt(0)?.toUpperCase()
      );
    },
    buildCommentHierarchy(comments) {
      const map = {};
      const roots = [];

      // Initialize comment map with replies array
      for (const comment of comments) {
        map[comment._id] = { ...comment, replies: [] };
      }

      // Build tree structure
      for (const comment of comments) {
        if (comment.replied_to && map[comment.replied_to]) {
          map[comment.replied_to].replies.push(map[comment._id]);
        } else {
          roots.push(map[comment._id]);
        }
      }

      return roots;
    },
    async like() {
      const response = await postAPICall(
        "POST",
        "/forums/like-thread/" + this.forumData._id
      );
      if (response.success) {
        this.forumData.liked_by.push(this.getAuthenticatedUser._id);
      } else {
        this.$message.error("Something went wrong !");
      }
    },
    async dislike() {
      const response = await postAPICall(
        "POST",
        "/forums/dislike-thread/" + this.forumData._id
      );
      if (response.success) {
        this.forumData.liked_by.splice(
          this.forumData.liked_by.indexOf(this.getAuthenticatedUser._id),
          1
        );
      } else {
        this.$message.error("Something went wrong !");
      }
    },
    scrollToComments(id) {
      const section = document.getElementById(id);
      if (section) section.scrollIntoView({ behavior: "smooth" });
      window.CKEDITOR.instances[this.editorConfig.id].focus();
    },
    reply(comment) {
      this.replyToComment = comment;
      this.replyToUser = this.allComments.find(
        (c) => c._id == comment
      ).created_by;
      this.scrollToComments("post-comment-section");
    },
    async postComment() {
      if (!this.comment) {
        this.$notify.error({
          title: "Error",
          message:
            "Comment cannot be empty. Please write something before submitting.",
        });
        return;
      }
      let response;
      if (this.replyToComment) {
        response = await postAPICall(
          "POST",
          "/forums/reply-to-comment/" + this.replyToComment,
          {
            comment: this.comment,
          }
        );
      } else {
        response = await postAPICall(
          "POST",
          "/forums/post-comment/" + this.forumData._id,
          {
            comment: this.comment,
          }
        );
      }
      if (response.success) {
        this.$notify.success({
          title: "Success",
          message:
            (this.replyToComment ? "Replied to the " : " Posted the ") +
            "comment successfully",
        });
        await this.fetchComments();
        this.scrollToComments("comment-section");
        this.replyToComment = "";
        this.replyToUser = "";
        this.comment = "";
        window.CKEDITOR.instances[this.editorConfig.id].setData("");
      } else {
        this.$notify.error({
          title: "Error",
          message: "Something went wrong",
        });
      }
    },
    async fetchComments() {
      this.totalComments = 0;
      let comments = await postAPICall(
        "GET",
        "/forums/get-thread-comments/" + this.$route.params.forum_id
      );
      if (comments.data.length) {
        this.totalComments = comments.data.length;
        this.allComments = comments.data;
        this.comments = this.buildCommentHierarchy(comments.data);
      }
    },
    addComment() {
      this.replyToComment = "";
      this.replyToUser = "";
      this.comment = "";
      this.scrollToComments("post-comment-section");
    },
    openTag(tag) {
      this.$router.push({
        path: "/forums",
        query: {
          tag: tag,
          ...this.$route.query,
        },
      });
    },
    askQuestion() {
      let path = this.isApplicationUser ? "/ap/create-forum" : "/create-forum";
      this.$router.push({
        path,
      });
    },
    openForum(forum_id) {
      let url = this.isApplicationUser ? "/ap/forum/" : "/forum/";
      this.$router.push({
        path: url + forum_id,
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  watch: {
    "$route.params.forum_id"() {
      this.getNecessaryInfo();
    },
  },
};
</script>
<style>
.initial {
  grid-template-columns: 35px auto;
  margin-top: 3px;
  margin-bottom: 3px;

  .icon {
    border: 1px solid #ffa9a9;
    text-align: center;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    padding: 5px;
    background-color: #f1494910;

    .initial-text {
      font-size: 1.2em;
      font-weight: 470;

      span {
        color: #f14949;
      }
    }
  }
}
.tag-box {
  border: 1px solid #e0e0e0;
  padding: 12px;
  border-radius: 4px;
  background-color: #fff;
}

.tag-header {
  font-weight: 600;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
}

.tag-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  border-top: 1px solid #f0f0f0;
  font-size: 14px;
}

.centered {
  display: flex;
  justify-content: center; 
  align-items: center;      
  height: 100%;             
}
</style>
